import { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "sonner";
import swal from "sweetalert";
import Annexture from "./Annexture.js";
import CustomLoader from "../static/CustomLoader.js";
import { getDropDownVal } from "../dropdownUtils.js";
import {
  MasterPage,
  MasterToolbar,
  MasterButton,
  MasterSearch,
  MasterGrid,
  MasterDialog,
  MasterConfirmDialog,
} from "../static/Masterpage";

const AnnextureListing = () => {
  const apiUrl = localStorage.getItem("apiUrl");
  const dbTokenData = localStorage.getItem("dbTokenData");

  const headers = {
    Authorization: `Bearer ${dbTokenData}`,
    "Content-Type": "application/json",
    dbMaster: "",
  };

  const [loading, setLoading] = useState(false);
  const [annextures, setAnnextures] = useState([]);
  const [typeData, setTypeData] = useState([]);
  const [filterData, setFilterData] = useState([]);
  const [serach, setSerach] = useState("");
  const [selectedData, setSelectedData] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [addShow, setAddShow] = useState(false);
  const [editShow, setEditShow] = useState(false);
  const [density, setDensity] = useState("standard");

  const addHandleShow = () => {
    setAddShow(true);
  };

  const addHandleClose = () => {
    setShowConfirm(true);
  };

  const editHandleShow = () => {
    if (selectedData.length > 1 || selectedData.length === 0) {
      toast.warning("Please Select only one value");
      return;
    }

    setEditShow(true);
  };

  const editHandleClose = () => {
    setShowConfirm(true);
  };

  const handleConfirmClose = () => {
    setShowConfirm(false);
    setAddShow(false);
    setEditShow(false);
  };

  const handleCancelClose = () => {
    setShowConfirm(false);
  };

  const fetchtypeOptions = () => {
    try {
      const response = getDropDownVal("ATP");

      const actOption = response.map((op) => ({
        value: op.code,
        label: op.value,
      }));

      setTypeData(actOption);
    } catch (error) {
      console.log("error");
    }
  };

  const RemoveFunction = async () => {
    if (selectedData) {
      swal({
        title: "Do you want to remove?",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then(async (confirmDelete) => {
        if (confirmDelete) {
          setLoading(true);

          try {
            await axios.delete(apiUrl + "annexture/" + selectedData[0], {
              headers,
            });

            toast.success("Record removed successfully.");

            fetchData();
          } catch (error) {
            console.error("Error deleting record:", error);
          } finally {
            setLoading(false);
          }
        }
      });
    } else {
      toast.warning("Please Select at least one value");
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
    fetchtypeOptions();
  }, [refresh]);

  const fetchData = async () => {
    try {
      setLoading(true);

      const response = await axios.get(apiUrl + "annexture", { headers });

      setAnnextures(response.data || []);

      setFilterData(response.data || []);

      setRefresh(false);
      setSelectedData([]);
    } catch (error) {
      console.log("error " + error);
      setAnnextures([]);
    } finally {
      setLoading(false);
    }
  };

  const handlesearch = (event) => {
    const getSearch = event.target.value.toLowerCase();

    if (getSearch.length > 0) {
      const searchdata = filterData.filter((item) =>
        Object.keys(item).some((key) =>
          String(item[key]).toLowerCase().includes(getSearch),
        ),
      );

      setAnnextures(searchdata);
    } else {
      setAnnextures(filterData);
    }

    setSerach(getSearch);
  };

  const columns = [
    {
      field: "filename",
      headerName: "File Name",
      flex: 1,
      minWidth: 350,
      headerAlign: "left",
      align: "left",
    },
  ];

  return (
    <>
      <MasterPage>
        <MasterToolbar
          actions={
            <>
              <MasterButton
                variant="add"
                tooltip="Create new Document Library"
                onClick={addHandleShow}
                disabled={loading}
              >
                Add
              </MasterButton>

              <MasterButton
                variant="update"
                tooltip="Edit Selected Document Library"
                onClick={editHandleShow}
                disabled={loading}
              >
                Update
              </MasterButton>

              <MasterButton
                variant="danger"
                tooltip="Delete Selected Document Library"
                onClick={RemoveFunction}
                disabled={loading}
              >
                Delete
              </MasterButton>
            </>
          }
          search={
            <MasterSearch
              tooltip="Search by All"
              value={serach}
              onChange={handlesearch}
              inputRef={(input) => input && input.focus()}
            />
          }
        />

        <MasterGrid
          density={density}
          onDensityChange={(newDensityString) => setDensity(newDensityString)}
          rows={
            annextures !== null &&
            annextures.length > 0 &&
            Object.keys(annextures[0]).length !== 0
              ? annextures
              : []
          }
          columns={columns}
          onSelectionModelChange={(ids) => setSelectedData(ids)}
        />
      </MasterPage>

      {loading && <CustomLoader />}

      <MasterDialog
        open={addShow}
        onHide={addHandleClose}
        title="Add Document Library"
        maxWidth="md"
      >
        <Annexture
          selectedId=""
          mode="A"
          onHide={addHandleClose}
          setRefresh={setRefresh}
          typeData={typeData}
        />
      </MasterDialog>

      <MasterDialog
        open={editShow}
        onHide={editHandleClose}
        title="Edit Document Library"
        maxWidth="md"
      >
        <Annexture
          selectedId={selectedData && selectedData[0]}
          mode="U"
          onHide={editHandleClose}
          setRefresh={setRefresh}
          typeData={typeData}
        />
      </MasterDialog>

      <MasterConfirmDialog
        show={showConfirm}
        title="Close Confirmation"
        message="Are you sure you want to close this modal?"
        onConfirm={handleConfirmClose}
        onCancel={handleCancelClose}
      />
    </>
  );
};

export default AnnextureListing;
